import { PayloadAction, createSlice, nanoid } from '@reduxjs/toolkit'
import { UploadFile } from 'types'

type MaterialUploadState = {
  materialFiles: Record<string, UploadFile>
  materialIds: string[]
}

const initialState: MaterialUploadState = {
  materialFiles: {},
  materialIds: [],
}

const materialUploadSlice = createSlice({
  name: 'materialUpload',
  initialState,
  reducers: {
    reset() {
      return initialState
    },
    createMaterial(state, action: PayloadAction<UploadFile>) {
      const newMaterial = {
        ...action.payload,
        key: action.payload.key ?? nanoid(),
      }
      const newMaterialId = newMaterial.key

      state.materialFiles = {
        ...state.materialFiles,
        [newMaterialId]: newMaterial,
      }

      if (newMaterialId) {
        state.materialIds = [...state.materialIds, newMaterialId]
      }
    },
    removeMaterial(state, action: PayloadAction<string>) {
      const deletedMaterialId = action.payload

      state.materialIds = state.materialIds.filter(
        (materialId) => materialId !== deletedMaterialId
      )

      delete state.materialFiles[deletedMaterialId]
    },
    updateFileStatus(
      state,
      action: PayloadAction<{
        materialId: string
        status: UploadFile['state']
        uploadedId?: UploadFile['uploadedId']
      }>
    ) {
      const { materialId, status, uploadedId } = action.payload

      if (state.materialFiles[materialId]) {
        state.materialFiles[materialId].state = status
        state.materialFiles[materialId].uploadedId = uploadedId
      }
    },
  },
})

export const materialUploadActions = materialUploadSlice.actions
export const materialUploadReducer = materialUploadSlice.reducer
